import styled from 'styled-components/macro'

export const Separator = styled.div`
  width: 100%;
  height: 2px;
  background-color: black;
  border-bottom: 1px solid white;
`

export const VerticalSeparator = styled.div`
  height: 100%;
  width: 2px;
  background-color: black;
  border-right: 1px solid white;
`
